var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('h1',{staticStyle:{"color":"red","margin-top":"70px"}},[_vm._v(" Working in non-production environment. "),_c('v-btn',{attrs:{"icon":"","color":"pink"},on:{"click":_vm.hideAlert}},[_vm._v(" x ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }